export enum ActionType {
    Add = 'Add',
    Remove = 'Remove',
    Update = 'Update',
}
